

export const ErrorCard = ({ errorsMsg }) => {
    return (
        <div className="flex justify-center text-black text-center my-16 bg-[#ffd6e1] px-64 py-8 rounded-md font-semibold">
          {errorsMsg}
        </div>
    );
}


export const SuccesssCard = ({ msg }) => {
  return (
      <div className="flex justify-center text-black text-center my-16 bg-[#C1E1C1] px-64 py-8 rounded-md font-semibold">
        {msg}
      </div>
  );
}